export const slideImages = [
  {
    small: "imgs/Lirio oriental small.webp",
    desktop: "imgs/Lirio oriental.webp",
  },
  {
    small: "imgs/Lirio Asiático small.webp",
    desktop: "imgs/Lirio Asiático.webp",
  },
  {
    small: "imgs/Lirio de Agua small.webp",
    desktop: "imgs/Lirio de Agua.webp",
  },
  {
    small: "imgs/Lirio Tigre (Lilium lancifolium) small.webp",
    desktop: "imgs/Lirio Tigre (Lilium lancifolium).webp",
  },
  {
    small: "imgs/Lirio Blanco (Lilium candidum) small.webp",
    desktop: "imgs/Lirio Blanco (Lilium candidum).webp",
  },
];

export const slideInfo = [
  {
    titleKey: "carousel-oriental-title",
    descKey: "carousel-oriental-desc",
  },
  {
    titleKey: "carousel-asiatic-title",
    descKey: "carousel-asiatic-desc",
  },
  {
    titleKey: "carousel-water-title",
    descKey: "carousel-water-desc",
  },
  {
    titleKey: "carousel-tiger-title",
    descKey: "carousel-tiger-desc",
  },
  {
    titleKey: "carousel-white-title",
    descKey: "carousel-white-desc",
  },
];
